define('modules/editor/views/edit_element_popup',['require','exports','module','common/views/modal_layout','./edit_popup_header','./edit_popup_body','common/models/appstate','../models/editorstate','lib/util','ldsh!../templates/edit_element_popup','../behaviours/modal_movable'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    EditPopupHeaderView = require('./edit_popup_header'),
    EditPopupBodyView = require('./edit_popup_body'),
    AppState = require('common/models/appstate'),
    EditorState = require('../models/editorstate'),
    util = require('lib/util');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/edit_element_popup'),
    regions: {
      header: '.js-header',
      body: '.js-body',
      footer: '.js-footer',
    },
    className: 'ed-options-container ed-modal ed-options-draggable',

    // TODO: Search another strategy for property exclusions by popup, amp, etc...
    notPopupRelatedItems: [
      'page:defaults',
      'page:confirmation',
      'page:privacy',
      'page:conversion',
      'page:gtm',
      'page:jquery_selector',
      'page:privacy',
      'page:notification',
    ],

    initialize: function (options) {
      this.cleanUpPreviousModals();
      this.page = options.page;
      this.item = options.item;
      this.updateCollection();
      this.filterCollection();
      this.setupHeader();
      this.setupBody();
      this.$el.css({
        top: (window.innerHeight - 380) / 2 + 'px',
        left: (window.innerWidth - 840) / 2 + 'px',
      });
      this.listenTo(EditorState, EditorState.SELECTED_ELEMENT_CHANGE, this.hide);
    },

    updateCollection: function () {
      this.col = this[this.item ? 'item' : 'page'].getPropertyGroups().filter(function (pg) {
        return pg.editAllowed !== false;
      });

      try {
        this.$('input.colorpicker').spectrum('destroy');
      } catch (e) {}
      this.render();
    },

    filterCollection: function () {
      this.filterCollectionByAMP();
      this.filterCollectionByPopup();
    },

    filterCollectionByAMP: function () {
      var filter = EditorState.getAMPState() ? 'privacy' : 'notification';

      this.col = this.col.filter(function (col) {
        return col.name !== 'page:' + filter;
      });
    },

    filterCollectionByPopup: function () {
      var self = this;
      var filters = {
        popup: function (col) {
          return !self.notPopupRelatedItems.includes(col.name);
        },
        step: function (col) {
          return col.name !== 'page:popup';
        },
      };

      this.col = this.col.filter(EditorState.isCurrentStepPopup() ? filters.popup : filters.step);
    },

    setupHeader: function () {
      this.tabs = new EditPopupHeaderView({
        collection: this.getPopupCollection(),
        vm: this.viewModels,
      });
      this.listenTo(this.tabs, 'selected', this.changeTab);
      this.$header.show(this.tabs);
    },

    getPopupCollection: function () {
      if (EditorState.getAMPState()) {
        return this.col;
      }

      return this.col.filter(function (col) {
        return col.name !== 'form:customAMPScript';
      });
    },

    setupBody: function () {
      this.body = new EditPopupBodyView({
        collection: this.col,
        vm: this.viewModels,
      });

      this.$body.show(this.body);
    },

    cleanUpPreviousModals: function () {
      // remove all previous instances of this popup
      $('.ed-options-container').remove();
    },

    changeTab: function (i) {
      if (!this.tabs || !this.body) {
        return;
      }
      this._selectedTab = i;
      this.tabs.select(i);
      this.body.showNth(i);
    },

    onRender: function () {
      this.changeTab(this._selectedTab || 0);
      AppState.setPropsPopUpOpen(true);
    },

    onRemove: function () {
      AppState.setPropsPopUpOpen(false);
      //try to clean all colorpicker trash not collected
      $('.sp-container.sp-hidden').remove();
    },
  });

  util.mixin(module.exports, require('../behaviours/modal_movable'));
});

